import * as React from 'react';
import Box from '@mui/material/Box';

const style = {
  display: 'flex',
  width: '100%',
  height: '100%',
  borderRadius: '5px',
  bgcolor: 'background.paper',
  boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px',
  justifyContent: 'center',
  overflow: 'hidden',
};

export const BoxContainer = (props) => {
  return <Box sx={{ ...style, ...props.bg }}>{props.children}</Box>;
};
